@for (index of totalSegments | range; track index; let last = $last) {
  <div
    class="[ flex-1 h-full ]"
    [class.bg-brand]="index < filledSegments"
    [attr.data-cy]="'segmented-progress-segment-' + (index < filledSegments ? 'filled' : 'empty')"
    [ngClass]="last ? [] : [' border-ie', 'border-ie-2', 'border-ie-secondary']"
    >
  </div>
}
